module.exports = __webpack_public_path__ + "static/darkMode-15e716d21e6047fddcac0a539a7941c1.wav";